import { render } from "./template.vue?vue&type=template&id=1ad9dde1&scoped=true&ts=true"
import script from "./template.vue?vue&type=script&lang=ts"
export * from "./template.vue?vue&type=script&lang=ts"

import "./template.vue?vue&type=style&index=0&id=1ad9dde1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad9dde1"]])

export default __exports__